
import { Metamodel } from '../base/model';
import { type IAttribute, IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';

import { AzureMySqlLinkedService } from 'app/model/linkedservice/azure-db-mysql.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureMySql.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureMySql_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureMySql_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureMySqlLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureMySqlTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
    public static DATABASE: IAttribute;
    @Metamodel.attribute({
        display: stringResources.Database,
        templatable: true,
        association: 'DATABASE'
    })
    public database?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
